import useTranslation from '../../hooks/useTranslation'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'
import FloatingHeadline from '../../UI/FloatingHeadline/FloatingHeadline'
import Headline from '../ui/Headline'
import Text from '../ui/Text'
import ContactButton from '../ui/ContactButton'
import person from '../../../assets/image/contact/person.jpg'

function Contact() {
  const t = useTranslation()
  const { kicker, heading, question, body } = t.landing.contact
  return (
    <FullHeightContainer center id="kontakt">
      <div>
        <Container>
          <SlideInView>
            <FloatingHeadline text={kicker} />
            <Headline headline={heading} size="xlarge" className="mt-7" />
            <div className="mt-10 flex flex-col gap-8 md:flex-row md:items-end">
              <div className="md:w-1/2 shrink-0">
                <img src={person} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="flex flex-col gap-5 flex-1 md:pr-32">
                <Text text={question} size="xlarge" className="font-[400]" />
                <Text text={body} size="xlarge" />
                <ContactButton label="Kontakt aufnehmen" />
              </div>
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default Contact
